import Icon, { IconProps } from 'components/Icon/Icon.component';
import { MAIN_SITE_HOMEPAGE } from 'config';
import React, { ComponentProps } from 'react';
import { WrapperLink } from './wrapper-link';

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/
export type BaseHomePageLinkProps = ComponentProps<typeof WrapperLink> &
  Pick<IconProps, 'iconSize' | 'iconHeight'> & {
    svgIconComponent?: React.FunctionComponent<
      React.SVGProps<SVGSVGElement> & {
        title?: string;
      }
    >;
  };

/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/

const BaseHomepageLink = ({
  iconHeight,
  iconSize,
  href = MAIN_SITE_HOMEPAGE,
  svgIconComponent,
  ...otherProps
}: BaseHomePageLinkProps) => (
  <WrapperLink
    href={href}
    title="homepage"
    aria-label="homepage"
    noReferrer={false}
    target="_self"
    {...otherProps}
  >
    <Icon
      iconSize={iconSize}
      iconHeight={iconHeight}
      display="block"
      svgIconComponent={svgIconComponent}
    />
  </WrapperLink>
);

export { BaseHomepageLink };
